import React, { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';
import { host, token } from '../host';
import { toast } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { Card, FormControl, InputLabel, Select, Typography } from '@mui/material';
import styled from '@emotion/styled';
import LoadingIndicator from '../LoadingIndicator';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const organ = [
    'ТОО Довеку',
    'ТОО Азия Стиль',
    'ТОО 12 Месяцев Астана',
    'ТОО 12 Месяцев Алмата',
    'ТОО 12 Месяцев Павлодар',
    'ТОО 12 Месяцев Костанай',
    'ТОО 12 Месяцев Восток',
    'ТОО Азия Декор',
    'ТОО Азия Креатив',
];

export default function StickyHeadTable({ rows, columns }) {
    const location = useLocation();
    const [page, setPage] = useState(0);
    const [attributes, setAttributes] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [editName, setEditName] = useState('');
    const [editStatus, setEditStatus] = useState('');
    const [editCategory, setEditCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [type, setType] = useState([]); // Тип заявки (multiselect)
    const [categoryId, setCategoryId] = useState('');
    const [attributeId, setAttributeId] = useState([]); // Атрибуты (multiselect)
    const [city, setCity] = useState('');
    const [units, setUnits] = useState('');
    const [supplier, setSupplier] = useState('');
    const [doc, setDoc] = useState('');
    const [format, setFormat] = useState('video');
    const [comment, setComment] = useState('');
    const [responsible, setResponsible] = useState('');
    const [file, setFile] = useState(null);
    const [organization, setOrganization] = useState('');
    const [loading, setLoading] = useState(false);

    // Состояния для хранения фото и видео
    const [allImages, setAllImages] = useState([]);
    const [allVideos, setAllVideos] = useState([]);
    const [newImages, setNewImages] = useState([]);
    const [newVideos, setNewVideos] = useState([]);
    const [deletedImages, setDeletedImages] = useState([]);
    const [deletedVideos, setDeletedVideos] = useState([]);

    useEffect(() => {
        axios.get(`${host}/api/v1/category`)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
        axios.get(`${host}/api/v1/attribute`).then((response) => {
            setAttributes(response.data);
        }).catch(error => {
            console.log(error);
        });
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const formatDate = (isoDate) => {
        if (!isoDate) return '-';
        const date = new Date(isoDate);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
            .toString()
            .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date
                .getHours()
                .toString()
                .padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
        return formattedDate;
    };

    const handleEditClick = () => {
        {
            location.pathname == '/users' ?
                setType(selectedRow.type)
                :
                setType(selectedRow.type.split(','))
        }
        setEditName(selectedRow.name);
        setEditStatus(selectedRow.status);
        setEditCategory(selectedRow.categoryId);
        setCategoryId(selectedRow.categoryId);
        setAttributeId(selectedRow.mediaattributes?.map(attr => attr.attributeId)); // Инициализация атрибутов из mediaattributes
        setCity(selectedRow.city);
        setUnits(selectedRow.units);
        setSupplier(selectedRow.supplier);
        setDoc(selectedRow.doc);
        setFormat(selectedRow.format);
        setComment(selectedRow.comment);
        setResponsible(selectedRow.responsible);
        setOrganization(selectedRow.organization);

        // Инициализация массивов фото и видео
        setAllImages(selectedRow.images);
        setAllVideos(selectedRow.videos);

        setOpenModal(true);
        handleMenuClose();
    };

    const handleDeleteClick = async () => {
        try {
            setLoading(true);
            if (location.pathname === '/acts' || location.pathname == '/new/acts') {
                const apiEndpoint = `${host}/api/v1/media/${selectedRow.id}/media`;

                await axios.delete(apiEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            } else {
                const apiEndpoint = `${host}/api/v1/user/${selectedRow.id}/user`;

                await axios.delete(apiEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            }

            toast.success('Успешно удалено');
            window.location.reload();
        } catch (error) {
            toast.error('Ошибка удаления');
        }
        handleMenuClose();
    };

    const handleFileUpload = (e, type) => {
        const files = Array.from(e.target.files);
        files.forEach((file) => {
            if (type === 'image' && file.type.startsWith('image')) {
                setNewImages((prev) => [...prev, file]);
            } else if (type === 'video' && file.type.startsWith('video')) {
                setNewVideos((prev) => [...prev, file]);
            }
        });
    };

    const handleDeleteImage = (image) => {
        if (image.id) {
            setDeletedImages((prev) => [...prev, image.id]);
        }
        setAllImages((prev) => prev.filter((img) => img.id !== image.id));
    };

    const handleDeleteVideo = (video) => {
        if (video.id) {
            setDeletedVideos((prev) => [...prev, video.id]);
        }
        setAllVideos((prev) => prev.filter((vid) => vid.id !== video.id));
    };

    const handleSave = async () => {
        try {
            setLoading(true);

            if (location.pathname === '/acts') {
                for (const imageId of deletedImages) {
                    await axios.delete(`${host}/api/v1/photo/${imageId}/delete`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                }

                for (const videoId of deletedVideos) {
                    await axios.delete(`${host}/api/v1/video/${videoId}/delete`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                }

                // Обновление основных данных акта
                const formData = new FormData();
                formData.append('type', type.join(',')); // Преобразуем массив типов в строку
                formData.append('city', city);
                formData.append('units', units);
                formData.append('supplier', supplier);
                formData.append('doc', doc);
                formData.append('organization', organization);
                formData.append('comment', comment);
                formData.append('responsible', responsible);
                formData.append('categoryId', categoryId);
                formData.append('attributeId', attributeId.join(',')); // Преобразуем массив атрибутов в строку

                await axios.put(`${host}/api/v1/media/${selectedRow.id}/media`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                // Загрузка новых файлов
                for (const image of newImages) {
                    const formData = new FormData();
                    formData.append('path', image);
                    formData.append('mediaId', selectedRow.id);
                    await axios.post(`${host}/api/v1/photo/create`, formData, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }

                for (const video of newVideos) {
                    const formData = new FormData();
                    formData.append('path', video);
                    formData.append('mediaId', selectedRow.id);
                    await axios.post(`${host}/api/v1/video/create`, formData, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }
            } else if (location.pathname === '/new/acts') {
                for (const imageId of deletedImages) {
                    await axios.delete(`${host}/api/v1/photo/${imageId}/delete`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                }

                for (const videoId of deletedVideos) {
                    await axios.delete(`${host}/api/v1/video/${videoId}/delete`, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
                }

                // Обновление основных данных акта
                const formData = new FormData();
                formData.append('type', type.join(',')); // Преобразуем массив типов в строку
                formData.append('city', city);
                formData.append('units', units);
                formData.append('comment', comment);
                formData.append('organization', organization);
                formData.append('categoryId', categories[0].id);
                formData.append('attributeId', attributeId.join(','));

                await axios.put(`${host}/api/v1/media/${selectedRow.id}/media`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                // Загрузка новых файлов
                for (const image of newImages) {
                    const formData = new FormData();
                    formData.append('path', image);
                    formData.append('mediaId', selectedRow.id);
                    await axios.post(`${host}/api/v1/photo/create`, formData, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }

                for (const video of newVideos) {
                    const formData = new FormData();
                    formData.append('path', video);
                    formData.append('mediaId', selectedRow.id);
                    await axios.post(`${host}/api/v1/video/create`, formData, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                }
            } else {
                const formData = new FormData();
                formData.append('name', editName)
                formData.append('status', editStatus)

                axios.put(`${host}/api/v1/user/${selectedRow.id}/user`, formData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                }).then(res => {
                    toast.success('Успешно изменено');
                    window.location.reload();
                }).catch(err => {
                    toast.error('Ошибка изменения');
                })
            }

            toast.success('Успешно изменено');
            window.location.reload();
        } catch (error) {
            toast.error('Ошибка сохранения');
        } finally {
            setLoading(false);
            setOpenModal(false);
        }
    };

    return (
        <LoadingIndicator loading={loading}>
            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                <TableContainer sx={{ maxHeight: 440 }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row) => (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        {columns.map((column) => {
                                            if (column.id === 'actions') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        <IconButton
                                                            onClick={(event) => handleMenuClick(event, row)}
                                                        >
                                                            <MoreVertIcon />
                                                        </IconButton>
                                                        <Menu
                                                            anchorEl={anchorEl}
                                                            open={Boolean(anchorEl)}
                                                            onClose={handleMenuClose}
                                                        >
                                                            <MenuItem onClick={handleEditClick}>Изменить</MenuItem>
                                                            <MenuItem onClick={handleDeleteClick}>Удалить</MenuItem>
                                                        </Menu>
                                                    </TableCell>
                                                );
                                            }
                                            if (column.id === 'categoryId') {
                                                const category = categories.find(cat => cat.id === row.categoryId);
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {category ? category.name : '-'}
                                                    </TableCell>
                                                );
                                            }
                                            if (column.id === 'attributeId') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {row.mediaattributes.map(attr => attr.value).join(', ')}
                                                    </TableCell>
                                                )
                                            }
                                            if (column.id === 'user') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {row.user?.email}
                                                    </TableCell>
                                                )
                                            }
                                            if (column.id === 'createdAt') {
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {formatDate(row.createdAt)}
                                                    </TableCell>
                                                )
                                            }
                                            const value = row[column.id];
                                            return (
                                                <TableCell key={column.id} align={column.align}>
                                                    {column.id === 'lastentry'
                                                        ? formatDate(value) // Форматируем дату
                                                        : value}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />

                <Modal sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflowY: 'auto',
                    paddingBottom: '50px'
                }} open={openModal} onClose={() => setOpenModal(false)}>
                    <Paper sx={{ padding: 2, margin: 'auto', maxWidth: 400, marginTop: '10%' }}>
                        <h2 style={{ marginBottom: '15px' }}>Изменить</h2>
                        {location.pathname === '/users' &&
                            <>
                                <TextField
                                    fullWidth
                                    label="Имя"
                                    value={editName}
                                    onChange={(e) => setEditName(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                />
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">Роль</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={editStatus}
                                        label="Роль"
                                        onChange={(e) => setEditStatus(e.target.value)}
                                        sx={{ marginBottom: 2 }}
                                    >
                                        <MenuItem value={'ADMIN'}>АДМИН</MenuItem>
                                        <MenuItem value={'ADMINAUDITOR'}>ГЛАВНЫЙ РЕВИЗОР</MenuItem>
                                        <MenuItem value={'AUDITOR'}>РЕВИЗОР</MenuItem>
                                        <MenuItem value={'GUEST'}>МЕНЕДЖЕР</MenuItem>
                                    </Select>
                                </FormControl>
                            </>
                        }
                        {location.pathname === '/acts' && <>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Тип завяки</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    multiple
                                    value={type}
                                    label="Тип завяки"
                                    onChange={(e) => setType(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    <MenuItem value={'Брак'}>Брак</MenuItem>
                                    <MenuItem value={'Недопоставка'}>Недопоставка</MenuItem>
                                    <MenuItem value={'Пересорт'}>Пересорт</MenuItem>
                                    <MenuItem value={'Обычный'}>Обычный</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Категория</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={categoryId}
                                    label="Категория"
                                    onChange={(e) => setCategoryId(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    {categories.map(category => (
                                        <MenuItem value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Аттребуты</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    multiple
                                    value={attributeId}
                                    label="Аттребуты"
                                    onChange={(e) => setAttributeId(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    {attributes.map(category => (
                                        <MenuItem value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ width: '100%' }}>
                                <Select
                                    labelId="demo-multiple-name-label"
                                    id="demo-multiple-name"
                                    name='organization'
                                    value={organization}
                                    sx={{ marginBottom: 2 }}
                                    onChange={(e) => setOrganization(e.target.value)}
                                >
                                    {organ.map((item) => (
                                        <MenuItem
                                            sx={{
                                                width: '100%'
                                            }}
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Город</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={city}
                                    label="Город"
                                    onChange={(e) => setCity(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    <MenuItem value={'Актобе'}>Актобе</MenuItem>
                                    <MenuItem value={'Алмата'}>Алмата</MenuItem>
                                    <MenuItem value={'Астана'}>Астана</MenuItem>
                                    <MenuItem value={'Караганда'}>Караганда</MenuItem>
                                    <MenuItem value={'Костанай'}>Костанай</MenuItem>
                                    <MenuItem value={'Павлодар'}>Павлодар</MenuItem>
                                    <MenuItem value={'Семей'}>Семей</MenuItem>
                                    <MenuItem value={'Усть-Каменогорск'}>Усть-Каменогорск</MenuItem>
                                    <MenuItem value={'Шымкент'}>Шымкент</MenuItem>
                                    <MenuItem value={'Экибастуз'}>Экибастуз</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                fullWidth
                                label="Номер тр. Единицы"
                                value={units}
                                onChange={(e) => setUnits(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Поставщик"
                                value={supplier}
                                onChange={(e) => setSupplier(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Сопр. Документы"
                                value={doc}
                                onChange={(e) => setDoc(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Комментарий"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Ответственный"
                                value={responsible}
                                onChange={(e) => setResponsible(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />

                            {/* Отображение загруженных фото */}
                            <div style={{ marginBottom: '20px' }}>
                                <Typography variant="h6">Фото:</Typography>
                                {allImages.map((image) => (
                                    <div key={image.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <img src={host + image.path} alt="uploaded" style={{ width: '100px', marginRight: '10px' }} />
                                        <Button variant="outlined" color="error" onClick={() => handleDeleteImage(image)}>
                                            Удалить
                                        </Button>
                                    </div>
                                ))}
                            </div>

                            {/* Отображение загруженных видео */}
                            <div style={{ marginBottom: '20px' }}>
                                <Typography variant="h6">Видео:</Typography>
                                {allVideos.map((video) => (
                                    <div key={video.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <video controls style={{ width: '100px', marginRight: '10px' }}>
                                            <source src={host + video.path} type={video.type} />
                                        </video>
                                        <Button variant="outlined" color="error" onClick={() => handleDeleteVideo(video)}>
                                            Удалить
                                        </Button>
                                    </div>
                                ))}
                            </div>

                            {/* Загрузка новых файлов */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                <Button
                                    component="label"
                                    role={undefined}
                                    sx={{ width: '48%' }}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Загрузить фото
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'image')}
                                        accept="image/*"
                                    />
                                </Button>
                                <Button
                                    component="label"
                                    role={undefined}
                                    sx={{ width: '48%' }}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Загрузить видео
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'video')}
                                        accept="video/*"
                                    />
                                </Button>
                            </div>

                        </>}
                        {location.pathname === '/new/acts' && <>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Основные</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    multiple
                                    value={type}
                                    label="Тип завяки"
                                    onChange={(e) => setType(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    <MenuItem value={'Перевод на брак'}>Перевод на брак</MenuItem>
                                    <MenuItem value={'Уценка'}>Уценка</MenuItem>
                                    <MenuItem value={'Не ликвид'}>Не ликвид</MenuItem>
                                    <MenuItem value={'Списание бракованного товара'}>Списание бракованного товара</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Тип товара</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    multiple
                                    value={attributeId}
                                    label="Аттребуты"
                                    onChange={(e) => setAttributeId(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    {attributes.map(category => (
                                        <MenuItem value={category.id}>{category.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl sx={{ width: '100%' }}>
                                <Select
                                    labelId="demo-multiple-name-label"
                                    id="demo-multiple-name"
                                    name='organization'
                                    value={organization}
                                    sx={{ marginBottom: 2 }}
                                    onChange={(e) => setOrganization(e.target.value)}
                                >
                                    {organ.map((item) => (
                                        <MenuItem
                                            sx={{
                                                width: '100%'
                                            }}
                                            key={item}
                                            value={item}
                                        >
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">Город</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={city}
                                    label="Город"
                                    onChange={(e) => setCity(e.target.value)}
                                    sx={{ marginBottom: 2 }}
                                >
                                    <MenuItem value={'Актобе'}>Актобе</MenuItem>
                                    <MenuItem value={'Алмата'}>Алмата</MenuItem>
                                    <MenuItem value={'Астана'}>Астана</MenuItem>
                                    <MenuItem value={'Караганда'}>Караганда</MenuItem>
                                    <MenuItem value={'Костанай'}>Костанай</MenuItem>
                                    <MenuItem value={'Павлодар'}>Павлодар</MenuItem>
                                    <MenuItem value={'Семей'}>Семей</MenuItem>
                                    <MenuItem value={'Усть-Каменогорск'}>Усть-Каменогорск</MenuItem>
                                    <MenuItem value={'Шымкент'}>Шымкент</MenuItem>
                                    <MenuItem value={'Экибастуз'}>Экибастуз</MenuItem>
                                </Select>
                            </FormControl>
                            <TextField
                                fullWidth
                                label="Номер документа"
                                value={units}
                                onChange={(e) => setUnits(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />
                            <TextField
                                fullWidth
                                label="Комментарий"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                sx={{ marginBottom: 2 }}
                            />

                            {/* Отображение загруженных фото */}
                            <div style={{ marginBottom: '20px' }}>
                                <Typography variant="h6">Фото:</Typography>
                                {allImages.map((image) => (
                                    <div key={image.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <img src={host + image.path} alt="uploaded" style={{ width: '100px', marginRight: '10px' }} />
                                        <Button variant="outlined" color="error" onClick={() => handleDeleteImage(image)}>
                                            Удалить
                                        </Button>
                                    </div>
                                ))}
                            </div>

                            {/* Отображение загруженных видео */}
                            <div style={{ marginBottom: '20px' }}>
                                <Typography variant="h6">Видео:</Typography>
                                {allVideos.map((video) => (
                                    <div key={video.id} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                        <video controls style={{ width: '100px', marginRight: '10px' }}>
                                            <source src={host + video.path} type={video.type} />
                                        </video>
                                        <Button variant="outlined" color="error" onClick={() => handleDeleteVideo(video)}>
                                            Удалить
                                        </Button>
                                    </div>
                                ))}
                            </div>

                            {/* Загрузка новых файлов */}
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                                <Button
                                    component="label"
                                    role={undefined}
                                    sx={{ width: '48%' }}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Загрузить фото
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'image')}
                                        accept="image/*"
                                    />
                                </Button>
                                <Button
                                    component="label"
                                    role={undefined}
                                    sx={{ width: '48%' }}
                                    variant="contained"
                                    tabIndex={-1}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Загрузить видео
                                    <VisuallyHiddenInput
                                        type="file"
                                        onChange={(e) => handleFileUpload(e, 'video')}
                                        accept="video/*"
                                    />
                                </Button>
                            </div>

                        </>}

                        <Button onClick={handleSave} variant="contained" color="primary" sx={{ mr: 1 }}>
                            Сохранить
                        </Button>
                        <Button onClick={() => setOpenModal(false)} variant="outlined">
                            Отменить
                        </Button>
                    </Paper>
                </Modal>
            </Paper>
        </LoadingIndicator>
    );
}